module.exports = __webpack_public_path__ + "static/media/ug.755a1df7.svg";